import { __extends } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-tabs.css';

var getClassNameList = classNames.bind(styles);
var UitkTab = /** @class */ (function (_super) {
    __extends(UitkTab, _super);
    function UitkTab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.parentDiv = React.createRef();
        return _this;
    }
    UitkTab.prototype.render = function () {
        var _a;
        var selected = this.props.selected;
        var wrapperClassNames = getClassNameList('uitk-tabs-pane', (_a = {},
            _a["active"] = selected,
            _a));
        var _b = this.props, name = _b.name, children = _b.children, id = _b.id;
        return (React.createElement("div", { ref: this.parentDiv, key: name, role: "tabpanel", className: wrapperClassNames, id: id }, children));
    };
    UitkTab.displayName = 'UitkTab';
    return UitkTab;
}(React.Component));

export { UitkTab };
